export default __webpack_public_path__ + "static/media/celebration-pana-succes.65a462d4.png";